import React from 'react';
import {
  makeStyles,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from '@material-ui/core';
import EmptyResponse from './EmptyResponse';
import SrIconButton from 'core/srIconButton/srIconButton';
import { FlipToFront, GetApp } from '@material-ui/icons';
import { downloadBlob } from 'utils';
import ExpenseOverview from './expenseOverview';

const useStyles = makeStyles(() => ({
  container: {
    marginTop: 24,
  },
  contentContainer: {
    paddingLeft: 16,
    background: '#fff',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 48,
    alignItems: 'center',
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    padding: '0 15px',
    backgroundColor: '#191919',
  },
  title: {
    fontSize: '12px',
    color: 'rgba(255, 255, 255, 0.87)',
  },
  jsonContainer: {
    display: 'flex',
    padding: '15px 25px',
    textAlign: 'left',
    height: 'calc(100vh - 395px)',
    overflow: 'scroll',
    background: '#313131',

    '& pre': {
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      fontFamily: 'Roboto',
      fontSize: 13,
      lineHeight: '24px',
      letterSpacing: 0.24,
      color: '#fff',

      '& .key': {
        color: '#f5ec11',
      },

      '& .string': {
        color: '#f041f7',
      },
    },
  },
  fileNameText: {
    justifyContent: 'flex-start',
    flex: '0 0 40%',
  },
  buttons: {
    color: '#fff',
  },

  tabsContainer: {
    marginBottom: 24,
    borderBottom: '1px dashed rgba(0, 0, 0, 0.1)',
  },
  tabText: {
    fontWeight: 500,
    fontSize: 14,
  },
  table: {
    width: '100%',
  },
  rowsContainer: {
    maxHeight: 'calc(100vh - 365px)',
  },
}));

const ParsedResume = ({ resume = null, fileName = '', isParsing }) => {
  const classes = useStyles();
  const [tab, setTab] = React.useState(0);
  console.log(resume);

  if (!resume) {
    return <EmptyResponse isParsing={isParsing} />;
  }

  const syntaxHighlight = (json) => {
    json = json
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    return json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
      function (match) {
        var cls = 'string';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key';
          }
        }

        return '<span class="' + cls + '">' + match + '</span>';
      }
    );
  };

  const getStringifiedResume = () => {
    const { rows = [], ...jsonContent } = resume || {};

    return {
      json: JSON.stringify(jsonContent, '\t', 4),
      rows,
      content: JSON.stringify(resume || {}, '\t', 4),
    };
  };

  const onClickCopy = () =>
    navigator.clipboard.writeText(getStringifiedResume().content);

  const onClickDownload = () => {
    const bytes = new TextEncoder().encode(getStringifiedResume().content);
    const blob = new Blob([bytes], {
      type: 'application/json;charset=utf-8',
    });

    downloadBlob(blob, fileName ? `${fileName}.json` : 'parsedDocument.json');
  };

  const ParsedJson = () => {
    return (
      <>
        <div className={classes.header}>
          <Typography classes={{ root: classes.title }}>
            {fileName || ''}
          </Typography>
          <div className={classes.buttons}>
            <SrIconButton
              Icon={GetApp}
              tooltip="Download as JSON"
              onClick={onClickDownload}
              color={'inherit'}
            />
            <SrIconButton
              Icon={FlipToFront}
              tooltip="Copy JSON"
              onClick={onClickCopy}
              color={'inherit'}
            />
          </div>
        </div>
        <div className={classes.jsonContainer}>
          <pre
            dangerouslySetInnerHTML={{
              __html: syntaxHighlight(getStringifiedResume().content),
            }}
          />
        </div>
      </>
    );
  };

  const ParsedRows = () => {
    const rows = getStringifiedResume().rows;

    return (
      <>
        <div className={classes.header}>
          <Typography classes={{ root: classes.title }}>
            {fileName || ''}
          </Typography>
        </div>
        <div>
          <TableContainer component={Paper} className={classes.rowsContainer}>
            <Table className={classes.table} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Sr. No.</TableCell>
                  <TableCell align="left">Field</TableCell>
                  <TableCell align="left">Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) =>
                  Object.keys(row).map((key, i) => (
                    <TableRow>
                      {i === 0 ? (
                        <TableCell rowSpan={Object.keys(row).length}>
                          {index + 1}
                        </TableCell>
                      ) : null}

                      <TableCell align="left">{key}</TableCell>
                      <TableCell align="left">{row[key]}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </>
    );
  };

  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <Tabs
          value={tab}
          indicatorColor="primary"
          textColor="primary"
          onChange={(_e, value) => setTab(value)}
          aria-label="Nav Tabs"
          classes={{ root: classes.tabsContainer }}
        >
          {['Overview', 'Line Items', 'JSON'].map((label) => (
            <Tab
              label={
                <Typography classes={{ root: classes.tabText }}>
                  {label}
                </Typography>
              }
            />
          ))}
        </Tabs>
        {tab === 0 && <ExpenseOverview json={resume} />}
        {tab === 1 && <ParsedRows />}
        {tab === 2 && <ParsedJson />}
      </div>
    </div>
  );
};

export default ParsedResume;
